/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free random number generator and UUID generator. Pick a range and count, or generate UUID v4 in bulk — instant and in your browser.`)
};

const es_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de números aleatorios gratuito y generador de UUID. Elige un rango y cantidad, o genera UUID v4 en masa — instantáneo y en tu navegador.`)
};

const de_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zufallszahlengenerator und UUID-Generator. Wähle einen Bereich und eine Anzahl, oder generiere UUID v4 in großen Mengen — sofort und in deinem Browser.`)
};

const nl_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis generator voor willekeurige nummers en UUID. Kies een bereik en aantal, of genereer UUID v4 in bulk — instant en in uw browser.`)
};

const fr_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de nombres aléatoires gratuit et générateur UUID. Choisissez une plage et un nombre, ou générez des UUID v4 en masse — instantané et dans votre navigateur.`)
};

const it_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore gratuito di numeri casuali e UUID. Scegli un intervallo e un numero, oppure genera UUID v4 in massa — istantaneo e nel tuo browser.`)
};

const pt_br2_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito de números aleatórios e gerador de UUID. Escolha um intervalo e contagem, ou gere UUID v4 em massa — instantaneamente e no seu navegador.`)
};

const pt_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito de números aleatórios e UUID. Escolha um intervalo e uma contagem, ou gere UUID v4 em massa — instantâneo e no seu navegador.`)
};

const ja_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のランダム番号ジェネレータとUUIDジェネレータ。範囲とカウントを選択するか、UUID v4を一括生成します。即座にブラウザで実行可能です。`)
};

const zh_rg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的随机数生成器和UUID生成器。选择范围和数量，或批量生成第4版UUID——即时完成，全程在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_tool_description", locale)
	if (locale === "en") return en_rg_tool_description(inputs)
	if (locale === "es") return es_rg_tool_description(inputs)
	if (locale === "de") return de_rg_tool_description(inputs)
	if (locale === "nl") return nl_rg_tool_description(inputs)
	if (locale === "fr") return fr_rg_tool_description(inputs)
	if (locale === "it") return it_rg_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_rg_tool_description(inputs)
	if (locale === "pt") return pt_rg_tool_description(inputs)
	if (locale === "ja") return ja_rg_tool_description(inputs)
	return zh_rg_tool_description(inputs)
};